var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "yoyo-container mx-auto min-h-screen bg-gray-50 pb-[env(safe-area-inset-bottom)]",
    },
    [
      _c("navBar"),
      _c(
        "div",
        {
          staticClass:
            "m-4 bg-white rounded-2xl p-4 pt-4 pb-3 shadow-sm user-info-card",
          style: _vm.cardStyle,
        },
        [
          _c(
            "h2",
            {
              staticClass: "text-xl font-semibold text-gray-800",
              on: { click: _vm.handleLogin },
            },
            [
              _vm._v(
                _vm._s(_vm.userInfo.nickname || _vm.$t("common.pleaseLogin"))
              ),
            ]
          ),
          _vm.isLoggedIn
            ? _c("div", { staticClass: "flex items-center mt-1" }, [
                _vm.userInfo.countryIcon
                  ? _c("img", {
                      staticClass: "w-5 h-auto mr-2 border border-gray-200",
                      attrs: {
                        src: _vm.imageBaseUrl + _vm.userInfo.countryIcon,
                      },
                    })
                  : _vm._e(),
                _c("span", { staticClass: "text-gray-600 text-sm" }, [
                  _vm._v(
                    _vm._s(
                      _vm.isZh
                        ? _vm.userInfo.countryName
                        : _vm.userInfo.countryNameEn
                    )
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.isLoggedIn
            ? _c(
                "div",
                { staticClass: "flex items-center justify-between mt-2" },
                [
                  _c("div", { staticClass: "flex-1 flex items-center mr-3" }, [
                    _c("img", {
                      staticClass: "w-12 h-12 mr-1",
                      attrs: {
                        src:
                          _vm.imageBaseUrl +
                          (_vm.userInfo.level && _vm.userInfo.level.icon),
                      },
                    }),
                    _c("span", { staticClass: "text-blue-600 font-medium" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.isZh
                              ? _vm.userInfo.level && _vm.userInfo.level.name
                              : _vm.userInfo.level && _vm.userInfo.level.nameEn
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "text-sm text-gray-500 mt-1 flex items-center",
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("yoyoCoins.currentBalance")) + " "
                      ),
                      _c(
                        "span",
                        {
                          staticClass:
                            "text-xl font-semibold text-gray-700 ml-2",
                        },
                        [_vm._v(_vm._s(_vm.userInfo.point))]
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm.isLoggedIn
        ? _c(
            "div",
            {
              staticClass:
                "mx-4 mt-4 bg-white rounded-xl overflow-hidden shadow-sm px-4",
            },
            [
              _c("van-cell", {
                attrs: { title: _vm.$t("mine.personalInfo"), "is-link": "" },
                on: {
                  click: function ($event) {
                    return _vm.goTo("/user-info")
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "flex items-center" }, [
                            _c("img", {
                              staticClass: "w-5 h-5 mr-1",
                              attrs: {
                                src: require("@/assets/images/mine/1.png"),
                              },
                            }),
                            _c("span", { staticClass: "text-gray-600" }, [
                              _vm._v(_vm._s(_vm.$t("mine.personalInfo"))),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  232287522
                ),
              }),
              _c("van-cell", {
                attrs: {
                  title: _vm.$t("mine.myBadges"),
                  border: false,
                  "is-link": "",
                },
                on: {
                  click: function ($event) {
                    return _vm.goTo("/my-badges")
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "flex items-center" }, [
                            _c("img", {
                              staticClass: "w-4 h-4 mr-2",
                              attrs: {
                                src: require("@/assets/images/mine/95.png"),
                              },
                            }),
                            _c("span", { staticClass: "text-gray-600" }, [
                              _vm._v(_vm._s(_vm.$t("mine.myBadges"))),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3165205992
                ),
              }),
              _c(
                "div",
                { staticClass: "flex items-center justify-between mt-0" },
                [
                  _c("div", { staticClass: "flex items-center space-x-2" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "w-12 h-12 rounded-full flex items-center justify-center border border-gray-200",
                        class:
                          _vm.userInfo.level && _vm.userInfo.level.level === 1
                            ? "bg-orange-100"
                            : "bg-white",
                      },
                      [
                        _c("img", {
                          staticClass: "w-10 h-10",
                          attrs: {
                            src: require("@/assets/images/huizhang/1.png"),
                          },
                        }),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "w-12 h-12 rounded-full flex items-center justify-center border border-gray-200",
                        class:
                          _vm.userInfo.level && _vm.userInfo.level.level === 2
                            ? "bg-orange-100"
                            : "bg-white",
                      },
                      [
                        _c("img", {
                          staticClass: "w-10 h-10",
                          attrs: {
                            src: require("@/assets/images/huizhang/2.png"),
                          },
                        }),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "w-12 h-12 rounded-full flex items-center justify-center border border-gray-200",
                        class:
                          _vm.userInfo.level && _vm.userInfo.level.level === 3
                            ? "bg-orange-100"
                            : "bg-white",
                      },
                      [
                        _c("img", {
                          staticClass: "w-10 h-10",
                          attrs: {
                            src: require("@/assets/images/huizhang/3.png"),
                          },
                        }),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "w-12 h-12 rounded-full flex items-center justify-center border border-gray-200",
                        class:
                          _vm.userInfo.level && _vm.userInfo.level.level === 4
                            ? "bg-orange-100"
                            : "bg-white",
                      },
                      [
                        _c("img", {
                          staticClass: "w-10 h-10",
                          attrs: {
                            src: require("@/assets/images/huizhang/4.png"),
                          },
                        }),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "w-12 h-12 rounded-full flex items-center justify-center border border-gray-200",
                        class:
                          _vm.userInfo.level && _vm.userInfo.level.level === 5
                            ? "bg-orange-100"
                            : "bg-white",
                      },
                      [
                        _c("img", {
                          staticClass: "w-10 h-10",
                          attrs: {
                            src: require("@/assets/images/huizhang/5.png"),
                          },
                        }),
                      ]
                    ),
                  ]),
                ]
              ),
              _c("div", { staticClass: "mt-4 text-[13px] text-gray-600" }, [
                _vm._v(" " + _vm._s(_vm.$t("mine.currentPoints")) + " "),
                _c("span", { staticClass: "font-semibold text-[#ff7a00]" }, [
                  _vm._v(_vm._s(_vm.userInfo.totalPoint)),
                ]),
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("mine.points")) +
                    "，" +
                    _vm._s(_vm.$t("mine.currentLevel")) +
                    "：" +
                    _vm._s(
                      _vm.isZh
                        ? _vm.userInfo.level && _vm.userInfo.level.name
                        : _vm.userInfo.level && _vm.userInfo.level.nameEn
                    ) +
                    " "
                ),
              ]),
              _c("div", {
                staticClass: "h-[1px] border-b border-gray-200 my-3 mb-2",
              }),
              _c("van-cell", {
                attrs: {
                  title: _vm.$t("mine.myYoyoCoins"),
                  "is-link": "",
                  border: false,
                },
                on: {
                  click: function ($event) {
                    return _vm.goTo("/yoyo-coins")
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "flex items-center" }, [
                            _c("img", {
                              staticClass: "w-4 h-4 mr-2",
                              attrs: {
                                src: require("@/assets/images/mine/2.png"),
                              },
                            }),
                            _c("span", { staticClass: "text-gray-600" }, [
                              _vm._v(_vm._s(_vm.$t("mine.myYoyoCoins"))),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3198284280
                ),
              }),
              _c("div", { staticClass: "space-y-1 text-[13px]" }, [
                _c("div", { staticClass: "flex" }, [
                  _c("span", { staticClass: "text-gray-600" }, [
                    _vm._v(_vm._s(_vm.$t("mine.accumulated")) + "："),
                  ]),
                  _c("span", { staticClass: "font-medium" }, [
                    _vm._v(_vm._s(_vm.userInfo.totalPoint)),
                  ]),
                ]),
                _c("div", { staticClass: "flex" }, [
                  _c("span", { staticClass: "text-gray-600" }, [
                    _vm._v(_vm._s(_vm.$t("mine.used")) + "："),
                  ]),
                  _c("span", { staticClass: "font-medium" }, [
                    _vm._v(" " + _vm._s(_vm.userInfo.usePoint) + " "),
                    _vm.isLoggedIn
                      ? _c("span", { staticClass: "text-gray-400 ml-1" }, [
                          _vm._v(
                            "(" +
                              _vm._s(_vm.$t("mine.discountRM")) +
                              _vm._s(_vm.userInfo.usePointPrice) +
                              ")"
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _c("div", {}, [
                  _c("span", { staticClass: "text-gray-600" }, [
                    _vm._v(_vm._s(_vm.$t("yoyoCoins.currentBalance")) + "："),
                  ]),
                  _c("span", { staticClass: "font-medium" }, [
                    _vm._v(" " + _vm._s(_vm.userInfo.point) + " "),
                    _vm.isLoggedIn
                      ? _c("span", { staticClass: "text-gray-400 ml-1" }, [
                          _vm._v(
                            "(" +
                              _vm._s(
                                _vm.isZh
                                  ? _vm.userInfo.expireTip
                                  : _vm.userInfo.expireTipEn
                              ) +
                              ")"
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _c("div", {
                staticClass: "h-[1px] border-b border-gray-200 my-2 mb-2",
              }),
              _c("van-cell", {
                attrs: {
                  title: _vm.$t("mine.myCoupons"),
                  border: false,
                  "is-link": "",
                },
                on: {
                  click: function ($event) {
                    return _vm.goTo("/my-coupons")
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "flex items-center" }, [
                            _c("img", {
                              staticClass: "w-4 h-4 mr-2",
                              attrs: {
                                src: require("@/assets/images/mine/6.png"),
                              },
                            }),
                            _c("span", { staticClass: "text-gray-600" }, [
                              _vm._v(_vm._s(_vm.$t("mine.myCoupons"))),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2608001759
                ),
              }),
              _c("div", { staticClass: "space-y-1 text-[13px] pb-2" }, [
                _c("div", { staticClass: "flex" }, [
                  _c("span", { staticClass: "text-gray-600" }, [
                    _vm._v(_vm._s(_vm.$t("mine.unused")) + "："),
                  ]),
                  _vm.userInfo.coupon
                    ? _c("span", { staticClass: "font-medium" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.isZh
                                ? _vm.userInfo.coupon &&
                                    _vm.userInfo.coupon.name
                                : _vm.userInfo.coupon &&
                                    _vm.userInfo.coupon.nameEn
                            ) +
                            " "
                        ),
                        _c("span", { staticClass: "text-gray-400" }, [
                          _vm._v(
                            " (" +
                              _vm._s(_vm.$t("mine.validUntil2025")) +
                              " " +
                              _vm._s(
                                _vm.formatTime(
                                  _vm.userInfo.coupon &&
                                    _vm.userInfo.coupon.validEndTime
                                )
                              ) +
                              ") "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "flex" }, [
                  _c("span", { staticClass: "text-gray-600" }, [
                    _vm._v(_vm._s(_vm.$t("mine.used")) + "："),
                  ]),
                  _c("span", { staticClass: "font-medium" }, [
                    _vm._v(
                      _vm._s(_vm.userInfo.couponUseCount) +
                        _vm._s(_vm.isLoggedIn ? _vm.$t("mine.pieces") : "")
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.isLoggedIn
        ? _c(
            "div",
            {
              staticClass:
                "mx-4 mt-4 bg-white rounded-xl overflow-hidden shadow-sm px-4",
            },
            [
              _c("van-cell", {
                attrs: { title: _vm.$t("mine.myOrders"), "is-link": "" },
                on: {
                  click: function ($event) {
                    return _vm.goTo("/my-orders")
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "flex items-center" }, [
                            _c("img", {
                              staticClass: "w-4 h-4 mr-2",
                              attrs: {
                                src: require("@/assets/images/mine/97.png"),
                              },
                            }),
                            _c("span", { staticClass: "text-gray-600" }, [
                              _vm._v(_vm._s(_vm.$t("mine.myOrders"))),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  410576161
                ),
              }),
              _c("van-cell", {
                attrs: { title: _vm.$t("mine.reviews"), "is-link": "" },
                on: {
                  click: function ($event) {
                    return _vm.goTo("/my-reviews")
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "flex items-center" }, [
                            _c("img", {
                              staticClass: "w-4 h-4 mr-2",
                              attrs: {
                                src: require("@/assets/images/mine/98.png"),
                              },
                            }),
                            _c("span", { staticClass: "text-gray-600" }, [
                              _vm._v(_vm._s(_vm.$t("mine.reviews"))),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  236413454
                ),
              }),
              _c("van-cell", {
                attrs: { title: _vm.$t("mine.toDo"), "is-link": "" },
                on: {
                  click: function ($event) {
                    return _vm.goTo("/my-to-do")
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "flex items-center" }, [
                            _c("img", {
                              staticClass: "w-4 h-4 mr-2",
                              attrs: {
                                src: require("@/assets/images/mine/99.png"),
                              },
                            }),
                            _c("span", { staticClass: "text-gray-600" }, [
                              _vm._v(_vm._s(_vm.$t("mine.toDo"))),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1803032054
                ),
              }),
              _c("van-cell", {
                attrs: { title: _vm.$t("mine.favorites"), "is-link": "" },
                on: {
                  click: function ($event) {
                    return _vm.goTo("/my-favorites")
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "flex items-center" }, [
                            _c("img", {
                              staticClass: "w-4 h-4 mr-2",
                              attrs: {
                                src: require("@/assets/images/mine/100.png"),
                              },
                            }),
                            _c("span", { staticClass: "text-gray-600" }, [
                              _vm._v(_vm._s(_vm.$t("mine.favorites"))),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3828938000
                ),
              }),
              _c("van-cell", {
                attrs: {
                  title: _vm.$t("mine.binds"),
                  border: false,
                  "is-link": "",
                },
                on: {
                  click: function ($event) {
                    return _vm.goTo("/my-binds")
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "flex items-center" }, [
                            _c("img", {
                              staticClass: "w-4 h-4 mr-2",
                              attrs: {
                                src: require("@/assets/images/mine/bind_1.png"),
                              },
                            }),
                            _c("span", { staticClass: "text-gray-600" }, [
                              _vm._v(_vm._s(_vm.$t("mine.binds"))),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  11096155
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass:
            "mx-4 mt-4 bg-white rounded-xl overflow-hidden shadow-sm px-4",
        },
        [
          _c("van-cell", {
            attrs: { title: _vm.$t("mine.language"), "is-link": "" },
            on: {
              click: function ($event) {
                _vm.dialogVisible = true
              },
            },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function () {
                  return [
                    _c("div", { staticClass: "flex items-center" }, [
                      _c("img", {
                        staticClass: "w-4 h-4 mr-1",
                        attrs: { src: require("@/assets/images/mine/5.png") },
                      }),
                      _c("span", { staticClass: "text-gray-600" }, [
                        _vm._v(_vm._s(_vm.$t("mine.language"))),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c("van-cell", {
            attrs: {
              title: _vm.$t("mine.customerService"),
              "is-link": "",
              border: false,
            },
            on: { click: _vm.handleCustomService },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function () {
                  return [
                    _c("div", { staticClass: "flex items-center" }, [
                      _c("img", {
                        staticClass: "w-4 h-4 mr-1",
                        attrs: { src: require("@/assets/images/mine/101.png") },
                      }),
                      _c("span", { staticClass: "text-gray-600" }, [
                        _vm._v(_vm._s(_vm.$t("mine.customerService"))),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm.isLoggedIn
        ? _c(
            "div",
            { staticClass: "my-6 pb-10 flex justify-center" },
            [
              _c(
                "van-button",
                {
                  staticClass: "w-60 rounded-xl",
                  attrs: { plain: "", color: "#ff7a00" },
                  on: { click: _vm.handleLogout },
                },
                [_vm._v(_vm._s(_vm.$t("login.loggout")))]
              ),
            ],
            1
          )
        : _vm._e(),
      _c("TipDialog", {
        attrs: { visible: _vm.dialogVisible, type: "language" },
        on: {
          "update:visible": function ($event) {
            _vm.dialogVisible = $event
          },
          "button-click": _vm.handleButtonClick,
          close: _vm.handleClose,
        },
      }),
      _c(
        "CommonDialog",
        {
          attrs: {
            visible: _vm.logoutDialogVisible,
            buttons: [
              {
                text: this.$t("common.cancel"),
                type: "secondary",
                action: "cancel",
              },
              {
                text: this.$t("common.confirm"),
                type: "primary",
                action: "confirm",
              },
            ],
          },
          on: {
            "update:visible": function ($event) {
              _vm.logoutDialogVisible = $event
            },
            "button-click": _vm.handleLogoutDialog,
            close: _vm.handleLogoutDialogClose,
          },
        },
        [
          _c("div", { staticClass: "text-center" }, [
            _c("div", { staticClass: "mb-4" }, [
              _vm._v(" " + _vm._s(_vm.$t("login.logoutConfirm")) + " "),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }